import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { protectedResources } from '../b2c-config';


@Injectable({
  providedIn: 'root'
})
export class SingleSessionService {

  constructor(private http: HttpClient) { }

  postLoginRequestForSessionTracking(loginSession:LoginSession) {
    return this.http.post(`${protectedResources.realizerApi.endpoint}loginnotification/sendnotification`,loginSession);
  }
}

export interface LoginSession {
  statusType: string;
  userId: string;
  sessionCreatedEPOC: string;
}
